import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-projects8',
  templateUrl: './section-projects8.component.html',
  styleUrls: ['./section-projects8.component.css']
})
export class SectionProjects8Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
